import React, { useMemo } from 'react';

import { Dropdown, DropdownProps } from '@column/column-ui-kit';

import { Access } from '../types';

import {
  AccessIconCustom,
  AccessIconDefault,
  AccessIconFullAccess,
  AccessIconNoAccess,
  AccessIconViewOnly,
} from './AccessIcons';

interface Props {
  onChange: (value: Access) => void;
  showDefault?: boolean;
  value: Access;
  variant?: DropdownProps['variant'];
}

export const AccessDropdown: React.FC<Props> = ({ onChange, showDefault, value, variant }) => {
  const options = useMemo(() => {
    const defaultOption = showDefault
      ? [
          {
            label: 'Default',
            icon: <AccessIconDefault />,
            value: Access.Default,
          },
        ]
      : [];
    return [
      ...defaultOption,
      {
        label: 'No Access',
        icon: <AccessIconNoAccess />,
        value: Access.NoAccess,
      },
      {
        label: 'View Only',
        icon: <AccessIconViewOnly />,
        value: Access.ViewOnly,
      },
      {
        label: 'Full Access',
        icon: <AccessIconFullAccess />,
        value: Access.FullAccess,
      },
      {
        label: 'Custom',
        icon: <AccessIconCustom />,
        value: Access.Custom,
      },
    ];
  }, [showDefault]);

  return (
    <Dropdown
      active={value}
      variant={variant}
      size={'small'}
      options={options}
      onChange={(newValue) => onChange(newValue as Access)}
      fullWidth
      positionRight
    />
  );
};
